// extracted by mini-css-extract-plugin
export var content = "_oq-1";
export var fullScreen = "_oq-0";